import React from 'react';
import { ToolResultProps } from '../types';
import { FileText, CheckCircle2, AlertCircle } from "lucide-react";

const WordGetDocumentTextResult: React.FC<ToolResultProps> = ({ thought }) => {
  const { success } = thought;
  const isSuccess = success !== false;

  return (
    <div className="mt-1.5 px-1 py-1 flex items-center gap-2">
      <div className={`p-1 rounded-sm ${isSuccess ? 'bg-muted/40 text-muted-foreground' : 'bg-red-50 text-red-500'}`}>
        <FileText className="h-3.5 w-3.5" />
      </div>
      
      <div className="flex flex-col">
        <div className="flex items-center gap-1.5">
          <span className={`text-[11px] font-medium ${isSuccess ? 'text-foreground/80' : 'text-red-600'}`}>
            {isSuccess ? 'Document content fetched' : 'Fetch error'}
          </span>
          {isSuccess ? (
            <CheckCircle2 className="h-2.5 w-2.5 text-emerald-500/60" />
          ) : (
            <AlertCircle className="h-2.5 w-2.5 text-red-500/60" />
          )}
        </div>
        <span className="text-[10px] text-muted-foreground italic">
          {isSuccess ? 'Successfully extracted text for analysis' : 'Could not read active document content'}
        </span>
      </div>
    </div>
  );
};

export default WordGetDocumentTextResult;
